import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import scrollbar from '../../styles/scrollbar';
import BottomSheet from './BottomSheet';
import { renderEntry } from '../../eventLog';
import { useT } from '../../i18n';

const useStyles = createUseStyles({
  content: {
    padding: '0 16px 24px',
  },
  label: {
    color: ({ theme }) => theme.colorTextMuted,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '12px',
  },
  logBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    maxHeight: '50vh',
    overflowY: 'auto',
    ...scrollbar,
  },
  entry: {
    color: ({ theme }) => theme.colorTextMuted,
    fontSize: '12px',
    lineHeight: 1.4,
    padding: '4px 0',
    borderBottom: ({ theme }) => `1px solid ${theme.colorBorder}`,
  },
  empty: {
    color: ({ theme }) => theme.colorTextMuted,
    fontSize: '13px',
    textAlign: 'center',
    padding: '20px',
    opacity: 0.5,
  },
});

// The log is newest-first, so the newest entry is the first row and the sheet
// wants to open where it already is: at the top. It used to scroll a sentinel
// at the end of the list into view on open *and on every new entry*, which is
// what a chat window does — and a chat window is oldest-first. Here it put the
// reader at the oldest of fifty rows every time they opened the tab, and
// yanked them back down there whenever anything happened while they read.
// `BottomSheet` unmounts its children when closed, so an open starts at
// scrollTop 0 on its own; the fix is to do nothing.
function EventsSheet({ open, onClose, log }) {
  const theme = useTheme();
  const t = useT();
  const classes = useStyles({ theme });

  return (
    <BottomSheet open={open} onClose={onClose}>
      <div className={classes.content}>
        <div className={classes.label}>{t('log.title')}</div>
        <div className={classes.logBox}>
          {log.length === 0 && (
            <div className={classes.empty}>{t('log.emptySheet')}</div>
          )}
          {log.map((entry, i) => (
            <div key={entry.time + '-' + i} className={classes.entry}>
              {renderEntry(entry, t)}
            </div>
          ))}
        </div>
      </div>
    </BottomSheet>
  );
}

export default EventsSheet;
